














import { Component, Prop, Vue, Emit, Watch } from "vue-property-decorator";
import Hls from 'hls.js'

@Component
export default class extends Vue {

  @Prop() src!: string
  @Prop() title!: string
  @Prop() dec!: string
  @Prop({
    default: false
  }) visible!: boolean

  private hls: Hls | null = null

  get videoSrc(): string {
    // m3u8 由 hls.js 或 Safari 原生处理，不走 video 的 src 绑定
    return this.isM3u8(this.src) ? '' : this.src
  }

  @Emit('close') onClose() {
    return false
  }

  @Watch('visible')
  onVisibleChange(val: boolean) {
    if (val) {
      this.$nextTick(() => this.initPlayer())
    } else {
      this.destroyPlayer()
    }
  }

  @Watch('src')
  onSrcChange() {
    if (this.visible) {
      this.$nextTick(() => this.initPlayer())
    }
  }

  beforeDestroy() {
    this.destroyPlayer()
  }

  isM3u8(src: string): boolean {
    return !!src && /\.m3u8(\?|$)/i.test(src)
  }

  initPlayer() {
    const video = this.$refs.videoRef as HTMLVideoElement | undefined
    if (!video || !this.src) return

    this.destroyPlayer()

    if (this.isM3u8(this.src)) {
      if (Hls.isSupported()) {
        this.hls = new Hls()
        this.hls.loadSource(this.src)
        this.hls.attachMedia(video)
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = this.src
      }
    } else {
      video.src = this.src
    }
  }

  destroyPlayer() {
    if (this.hls) {
      this.hls.destroy()
      this.hls = null
    }
    const video = this.$refs.videoRef as HTMLVideoElement | undefined
    if (video) {
      video.pause()
      video.removeAttribute('src')
      video.load()
    }
  }
}
